import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/teamwork-polygon.png';

import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const REPORT_DATA = [
  {
    title: 'Case Management',
    items: [
      'Case Counts & Trends',
      'Client Listing Details',
      'Case Load Details',
      'Follow-up and Referrals',
    ],
  },
  {
    title: 'Service Analytics',
    items: [
      'Service Details',
      'Service Counts',
      'Service Averages & Totals',
      'Service Time & Costs',
    ],
  },
  {
    title: 'Compliance Reports',
    items: [
      'ROMA Next Gen',
      'Organizational Performance Standard Tracking',
      'Crisis to Thriving Scale Assessment Outcomes',
      'Board Minutes & Meetings',
    ],
  },
  {
    title: 'Agency-wide Efficiency',
    items: [
      'Auditable Demographic Reports',
      'Community Needs Assessments',
      'Volunteer Analytics',
      'Outreach Project Outcomes',
    ],
  },
];
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Centralized Intake',
  },
  {
    id: '02',
    title: 'Updated & Flexible Poverty Guidelines',
  },
  {
    id: '03',
    title: 'Streamlined Program Workflows',
  },
  {
    id: '04',
    title: 'Unduplicated Client Count',
  },
  {
    id: '05',
    title: 'USPS Address Verification',
  },
  {
    id: '06',
    title: 'Unlimited Document Upload',
  },
  {
    id: '07',
    title: 'Automated Eligibility Calculator',
  },
  {
    id: '08',
    title: 'Automated Referrals',
  },
  {
    id: '09',
    title: 'Internal Appointment Calendar',
  },
];
function CSBC() {
  return (
    <div>
      <Helmet>
        <title>Best CSBG Data Solution - CAP60</title>
        <meta
          name="description"
          content="CAP60 has created a comprehensive and integrated data management system that is defined by user friendliness and maximum agency-wide efficiency."
        />
        <meta
          name="keywords"
          content="csbg data solution, cap60 csbg data solution"
        />
      </Helmet>
      <PageBanner
        title="CSBG"
        subtitle="The most comprehensive CSBG Data Solution in the U.S"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful"
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Maximize agency-wide efficiency</h2>
          </div>
          <p>
            CAP60 has designed a comprehensive and integrated data management
            system that’s defined by ease of use and maximum agency-wide
            efficiency. From LIHEAP to Employment Assistance, our web-based
            system provides families the opportunity to participate in the
            multiple programs offered by various local and state Community
            Action Programs.
          </p>
          <p>
            With CAP60 you will have the ability to integrate and map all agency
            programs to ROMA Next Gen goals track outcomes for all programs. We
            also create unduplicated client reports and agency-wide demographic
            reports.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

function SampleReport() {
  return (
    <div className={styles.sampleReportWrapper}>
      <Container>
        <div className="heading">
          <h2>Sample Reports</h2>
        </div>
        <Row>
          {REPORT_DATA.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                <h3>{rdata.title}</h3>
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default CSBC;
